module.exports = __WEBPACK_EXTERNAL_MODULE_node_fetch__;